"use strict"; /** @module VCF */
var VCF = require('./parse');

module.exports = VCF;